/**
 * Color Swatches - Swap de produit au clic sur une pastille
 * Utilisé dans featured-collection.liquid
 */
(function () {
  'use strict';

  /**
   * Swap les éléments d'une card avec les données du produit frère cliqué
   */
  function swapCardContent(wrapper, swatch) {
    const cardContent = wrapper.querySelector('[data-card-content]');
    if (!cardContent) return;

    const newHandle = swatch.dataset.siblingHandle;
    const newUrl = swatch.dataset.siblingUrl;
    const newImage = swatch.dataset.siblingImage;
    const newImageHover = swatch.dataset.siblingImageHover;
    const newTitle = swatch.dataset.siblingTitle;
    const newPrice = swatch.dataset.siblingPrice;

    // Si on clique sur la pastille déjà active, on ne fait rien
    if (wrapper.dataset.currentHandle === newHandle) return;

    // Animation de fade
    cardContent.classList.add('is-swapping');

    setTimeout(() => {
      // 1. Swap de l'image principale
      const images = cardContent.querySelectorAll('img');
      images.forEach((img, index) => {
        // Première image = image principale
        if (index === 0 && newImage) {
          // Mettre à jour src et srcset
          img.src = newImage;
          if (img.srcset) {
            img.srcset = newImage;
          }
          // Mettre à jour l'attribut alt
          img.alt = newTitle || img.alt;
        }
        // Deuxième image = image hover (si elle existe)
        if (index === 1 && newImageHover) {
          img.src = newImageHover;
          if (img.srcset) {
            img.srcset = newImageHover;
          }
        }
      });

      // 2. Swap des liens (image + titre)
      const links = cardContent.querySelectorAll('a[href]');
      links.forEach((link) => {
        link.href = newUrl;
      });

      // 3. Swap du titre
      const titleSelectors = [
        '.card__heading',
        '.card-information__text',
        '.product-card__title',
        '[class*="card__title"]',
        '[class*="card-title"]',
      ];
      titleSelectors.forEach((selector) => {
        const titleEl = cardContent.querySelector(selector);
        if (titleEl && newTitle) {
          // Si le titre est dans un <a>, on remplace juste le texte du <a>
          const linkInside = titleEl.querySelector('a');
          if (linkInside) {
            linkInside.textContent = newTitle;
          } else {
            titleEl.textContent = newTitle;
          }
        }
      });

      // 4. Swap du prix
      const priceSelectors = [
        '.price-item--regular',
        '.price__regular .price-item',
        '.product-card__price',
        '[class*="price-item"]',
      ];
      priceSelectors.forEach((selector) => {
        const priceElements = cardContent.querySelectorAll(selector);
        priceElements.forEach((priceEl) => {
          if (newPrice) {
            priceEl.innerHTML = newPrice;
          }
        });
      });

      // 5. Mise à jour du handle courant sur le wrapper
      wrapper.dataset.currentHandle = newHandle;

      // 6. Mise à jour de l'état actif des pastilles
      const allSwatches = wrapper.querySelectorAll('[data-color-swatch]');
      allSwatches.forEach((s) => s.classList.remove('wt-color-swatch--active'));
      swatch.classList.add('wt-color-swatch--active');

      // Retirer le fade
      requestAnimationFrame(() => {
        cardContent.classList.remove('is-swapping');
      });
    }, 150);
  }

  /**
   * Initialise les listeners sur toutes les pastilles
   */
  function initColorSwatches() {
    const swatches = document.querySelectorAll('[data-color-swatch]');

    swatches.forEach((swatch) => {
      // Évite le double-binding si le script est rechargé
      if (swatch.dataset.swatchBound === 'true') return;
      swatch.dataset.swatchBound = 'true';

      swatch.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const wrapper = swatch.closest('[data-color-swatches-card]');
        if (!wrapper) return;

        swapCardContent(wrapper, swatch);
      });
    });
  }

  // Init au chargement
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initColorSwatches);
  } else {
    initColorSwatches();
  }

  // Re-init si Shopify recharge la section dans l'éditeur de thème
  document.addEventListener('shopify:section:load', initColorSwatches);
})();